import { Stack, TextField } from "@mui/material";
import React from "react";

const TextFieldVarValues = ({ params, setParams }) => {
  return (
    <div>
      {params.map((tok, index) => (
        <Stack
          key={tok.key}
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ mt: 2 }}
        >
          <code>{`{{${tok.key}}}`}</code>
          <TextField
            size="small"
            fullWidth
            label={`Value`}
            value={tok.value}
            onChange={(e) =>
              setParams((prev) =>
                prev.map((item) =>
                  item.key === tok.key
                    ? { ...item, value: e.target.value }
                    : item
                )
              )
            }
          />
        </Stack>
      ))}
    </div>
  );
};

export default TextFieldVarValues;
